import React from 'react';
import { Input, Select, Form, Button, message } from 'antd';
import { roles, getAllParents, getChildren, getCurrentUser } from '../../../utils/utils';
import '../../../global.scss';
import { AuthService } from '../../../services/auth.service';

const { Option } = Select;

class NewUserForm extends React.Component {

  state = {
    registering: false,
    edit: false,
    user: null,
    currentUser: getCurrentUser(),
    currentParent: 0,
    selectedRole: 1
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { form, onCreated, onEdited } = this.props;
    form.validateFields(async (err, user) => {
      try {
        if (user.role === 1) {
          user.organism = user.child;
        }
        if (this.state.edit) {
          delete user.password;
          const editedUser = await AuthService.updateUser(user, this.state.user.id);
          onEdited(editedUser);
        } else {
          const newUser = await AuthService.register(user);
          onCreated(newUser);
        }
      } catch (error) {
        message.error(error.toString());
      }
    });
  }


  static getDerivedStateFromProps(nextProps) {
    if (nextProps.edit) {
      return ({ user: nextProps.user, edit: true })
    }
    return ({ edit: false, user: null });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} layout="vertical" className="flex-form">
        {this.buildFields(getFieldDecorator).map(field => field.item)}
      </Form>
    );
  }

  buildFields = (getFieldDecorator) => [
    {
      key: 'firstname',
      item: <Form.Item key='firstname' className="third-input" label="Nombre">
        {getFieldDecorator('firstname', {
          rules: [{ required: true, message: 'Debe indicar el nombre de la persona' }],
          initialValue: (this.state.user && this.state.edit) ? this.state.user.person.firstname : null
        })(
          <Input className="full-input" />
        )}
      </Form.Item>
    },
    {
      key: 'lastname',
      item: <Form.Item key='lastname' className="third-input" label="Apellido">
        {getFieldDecorator('lastname', {
          rules: [{ required: true, message: 'Debe indicar el apellido de la persona' }],
          initialValue: (this.state.user && this.state.edit) ? this.state.user.person.lastname : null
        })(
          <Input />
        )}
      </Form.Item>
    },
    {
      key: 'dni',
      item: <Form.Item key='dni' className="third-input" label="Cedula">
        {getFieldDecorator('dni', {
          rules: [{ required: true, message: 'Debe indicar el cedula de la persona' }],
          initialValue: (this.state.user && this.state.edit) ? this.state.user.person.dni : null
        })(
          <Input />
        )}
      </Form.Item>
    },
    {
      key: 'email',
      item: <Form.Item key='email' className="third-input" label="Correo">
        {getFieldDecorator('email', {
          rules: [{ required: true, message: 'Debe indicar el correo de la persona' }],
          initialValue: (this.state.user && this.state.edit) ? this.state.user.email : null
        })(
          <Input />
        )}
      </Form.Item>
    },
    {
      key: 'username',
      item: <Form.Item key='username' className="third-input" label="Nombre de usuario">
        {getFieldDecorator('username', {
          rules: [{ required: true, message: 'Debe indicar el nombre de usuario' }],
          initialValue: (this.state.user && this.state.edit) ? this.state.user.username : null
        })(
          <Input />
        )}
      </Form.Item>
    },
    {
      key: 'password',
      item: <Form.Item key='password' className="third-input" label="Contraseña">
        {getFieldDecorator('password', {
          rules: [{ required: !this.state.edit, message: 'Debe indicar la contraseña.' }, { min: 6, message: 'Minimo 6 caracteres' }],
        })(
          <Input.Password disabled={this.state.edit} />
        )}
      </Form.Item>
    },
    {
      key: 'phone',
      item: <Form.Item key='phone' className="half-input" label="Telefono">
        {getFieldDecorator('phone', {
          rules: [{ required: true, message: 'Debe indicar el telefono.' }],
          initialValue: (this.state.user && this.state.edit) ? this.state.user.person.phone : null
        })(
          <Input />
        )}
      </Form.Item>
    },

    {
      key: 'role',
      item: <Form.Item key='role' className="half-input" label="Rol">
        {getFieldDecorator('role', {
          rules: [{ required: true, message: 'Debe indicar el rol del usuario.' }],
          initialValue: (this.state.user && this.state.edit) ? this.state.user.role : null
        })(
          <Select className="full-input" placeholder="Tipo de Usuario" onChange={(selectedRole) => this.setState({ selectedRole })}>
            {roles().map(role => (<Option key={role.key} value={role.key}>{role.name.toUpperCase()}</Option>))}
          </Select>
        )}
      </Form.Item>
    },
    {
      key: 'organism',
      item: <Form.Item key='organism' className="full-input" label="Secretaria ejecutiva">
        {getFieldDecorator('organism', {
          rules: [{ required: true, message: 'Debe indicar la institucion a la cual pertence.' }],
          initialValue: (this.state.user && this.state.edit) ? this.state.user.organism : null
        })(
          <Select className="full-input" onChange={(parent) => this.setState({ currentParent: parent })}>
            {getAllParents().map(owner => (<Option key={owner.id} value={owner.id}>{owner.name.toUpperCase()}</Option>))}
          </Select>

        )}
      </Form.Item>
    },
    {
      key: 'child',
      item: <Form.Item key='child' className="full-input" label="Institución">
        {getFieldDecorator('child', {
          rules: [{ required: (this.state.selectedRole === 1), message: 'Este campo es requerido' }]
        })(
          <Select
            placeholder="Institución"
            disabled={this.state.selectedRole !== 1}
          >
            {getChildren(this.state.currentParent).map((child, i) =>
              < Option key={i} value={child.id} > {child.name}</Option>
            )}
          </Select>
        )}
      </Form.Item>
    },
    {
      key: 'submit',
      item: <Form.Item key='submit' className="full-input">
        <Button
          type="primary"
          htmlType="submit"
          className="full-input">
          {this.state.edit ? 'Editar' : 'Completar'}
        </Button>
      </Form.Item>
    }
  ]

}

const NewUser = Form.create({ name: 'add_user' })(NewUserForm);

export default NewUser;
